import axios from 'axios';
import React, { useEffect, useMemo, useState } from 'react'
import BASEURL from '../../../Config/global';
import { useDispatch, useSelector } from 'react-redux';
import { appendTracksToPlaylist, setConfig, setCreatePlaylistType, setSelectedItem } from '../../../Store/Slices/PlayerSlice';
import { getPlaylistConfig, getPlaylistType, hasSingleType } from '../../../Util/helpers';
import { Modal } from 'react-bootstrap';
import { handleCreatePlaylistModal, handlePlaylistTray, handleSuccessModal } from '../../../Store/Slices/ModalSlice';
import { OnRefresh } from '../../../Services/RefreshObservable';
import { useTranslation } from 'react-i18next';

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const AddToPlaylist = ({ config_list }) => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { selectedId, config } = useSelector((state) => state.player);

    const [playlists, setPlaylists] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [query, setQuery] = useState('');


    useEffect(() => {
        const sub = OnRefresh().subscribe((data) => {
            getDataByApi();
        });
        return () => sub.unsubscribe();
    }, []);

    useEffect(() => {
        getDataByApi();
    }, [])

    const getDataByApi = async () => {
        try {
            setLoading(true);
            const url = `${BASEURL}/api/user/playlists/?playlist_type=${config_list?.playlist_type}`;
            const response = await axios.get(url);
            if (!response.data.error) {
                const reordered = reorderList(response.data.data, selectedId);
                setPlaylists(reordered);
                // console.log(playlists)
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }

    const getApiDataById = async (id) => {
        try {
            const response = await axios.get(`${BASEURL}/api/user/playlists/${id}`);
            if (!response.data.error) {
                return response.data.data;
            }
        } catch (error) {
            console.log(error)
        }
    }

    const selectPlaylist = async (idx) => {

        const isBlocked = await checkAvailableForPlaylist(playlists[idx]['playlist_type']);
        if (isBlocked) return;

        const configId = config_list?.id;
        const configData = config_list?.data;
        const selectedId = playlists[idx]['id'];
        const selectedName = playlists[idx]['name'];
        const selectedType = playlists[idx]['playlist_type'];
        // const getSelectedData = await getApiDataById(selectedId);
        // const selectedList = getSelectedData['tracks'];
        const selectedList = playlists[idx]['tracks'];
        const exists = configData.some(a2 => selectedList.some(a1 => a1.id === a2.id));

        if (!exists) {
            const mergedData = [...selectedList, ...configData];

            if (selectedId === config.id) {
                dispatch(appendTracksToPlaylist(configData));
                dispatch(setConfig({ data: mergedData }))
            }

            const payload = {
                name: selectedName,
                tracks: getPlaylistConfig(mergedData),
                playlist_type: config_list?.playlist_type !== "default" ? config_list?.playlist_type : selectedType,
            }

            const response = await axios.patch(`${BASEURL}/api/user/playlists/${selectedId}/`, payload);

            if (!response?.data?.error) {
                dispatch(handlePlaylistTray(false));
                getDataByApi();
                dispatch(
                    handleSuccessModal({
                        open: true,
                        msg: t('playlists.playlistUpdatedSuccessfully')
                    })
                );
                setTimeout(() => {
                    dispatch(
                        handleSuccessModal({
                            open: false,
                            msg: "",
                        })
                    );
                }, 3000);
            }
        } else {
            setShowModal({
                open: true,
                msg: t('playlists.alreadyInPlaylist', { name: selectedName })
            });
        }

        setTimeout(() => {
            setShowModal({
                open: false,
                msg: ""
            });
        }, 1000);

    }

    const openCreatePlaylistModal = async () => {

        const isBlocked = await checkAvailableForPlaylist("default");


        const data = config_list?.data;
        const isLullaByAndMusic = config_list?.parent_category_id !== 163 && config_list?.parent_category_id !== 164;
        const isSoundExists = data.some(obj => obj.type == 'sounds' && obj.soundcategory !== 163 && obj.soundcategory !== 164);

        if (isBlocked) return;

        if (isLullaByAndMusic && isSoundExists) {
            const msg = t('playlists.cannotAddOnlySoundsToPlaylist');
            setShowModal({
                open: true,
                msg: msg
            });

            // Wait for 1 second before closing the modal and continuing
            await delay(2000);

            setShowModal({
                open: false,
                msg: ""
            });

            return true; // means sound exists (stop next steps)
        }

        const playlistType = getPlaylistType(config_list?.data[0]);
        dispatch(setSelectedItem(config_list?.data));
        dispatch(setCreatePlaylistType(playlistType));
        dispatch(handleCreatePlaylistModal(true));
        dispatch(handlePlaylistTray(false));
    }

    const checkAvailableForPlaylist = async (selected_playlist_type) => {
        if (!config_list?.shouldValidate) return false;

        const data = config_list?.data;
        const isSoundExists = data.some(obj => obj.type == 'sounds' && obj.soundcategory !== 163 && obj.soundcategory !== 164);
        const isPlaylistTypeMatched = selected_playlist_type === "default" ? true : selected_playlist_type === getPlaylistType(data[0]);


        debugger
        // if hasSingleType(data) is true which means it is available to add!!!
        if (!hasSingleType(data) || !isPlaylistTypeMatched || isSoundExists || config.type === 'playlist' || config.type === 'mix') {
            const msg = t('playlists.cannotAddToPlaylist');
            setShowModal({
                open: true,
                msg: msg
            });

            // Wait for 1 second before closing the modal and continuing
            await delay(1000);

            setShowModal({
                open: false,
                msg: ""
            });

            return true; // means sound exists (stop next steps)
        };

        return false; // safe to continue
    }

    const reorderList = (list, selectedId) => {
        // if already first or not found, return the same list reference (no re-render)
        if (!list?.length || list[0]?.id === selectedId) return list;

        const index = list.findIndex(item => item.id === selectedId);
        if (index <= 0) return list; // not found or already first

        // create a shallow copy and move only the matched item to front
        const newList = [...list];
        const [selectedItem] = newList.splice(index, 1);
        newList.unshift(selectedItem);

        return newList;
    };


    // memoized filtered playlists
    const filteredPlaylists = useMemo(() => {
        if (!query) return playlists;
        const q = query.toLowerCase();
        return playlists.filter(p => (p.title || p.name || '').toLowerCase().includes(q));
    }, [playlists, query]);

    return (
        <>

            <div className='px-3 pt-2'>
                <div>
                    <input
                        type="search"
                        placeholder={t("playlists.search")}
                        className="searchBar py-2 w-100"
                        value={query}
                        onKeyUp={(e) => e.code === "Space" && setQuery(e.target.value + ' ')}
                        onChange={(e) => setQuery(e.target.value)}
                    />
                </div>

                <button onClick={openCreatePlaylistModal} style={{ backgroundColor: '#ffffff1f', fontSize: '12px' }} className='my-2 w-100 px-5 fw-light text-white text-capitalize btn rounded-pill d-flex align-items-center justify-content-center flex-shrink-0'>
                    + {t("playlists.newPlaylist")}
                </button>

            </div>

            <div className='scrollable-container'>
                <div className='scrollable-content px-3' style={{ maxHeight: '200px', overflowY: 'auto' }}>
                    {loading && <div className="text-center text-muted small py-2">Loading...</div>}
                    {!loading && filteredPlaylists.length === 0 && (
                        <div className="text-center text-muted small py-2">{t('playlists.noPlaylistsFound')}</div>
                    )}
                    {!loading && filteredPlaylists.map((playlist, idx) => (
                        <div onClick={() => selectPlaylist(idx)} key={playlist.id ?? idx} className="mixerSoundDetail py-2 px-2 gap-1 cursor-pointer">
                            <div className="mixerSoundThumbnailWrapper d-flex" style={{ flex: '0 0 30px' }}>
                                {playlist?.tracks?.slice(0, 1)?.map((item, index) => (
                                    <div className="mixerAudioThumbnail" key={index}>
                                        <img src={item?.image} alt={item?.name} style={{ width: '25px' }} />
                                    </div>
                                ))}
                            </div>
                            <div className="flex-grow-1">
                                <p className={`mixerAudioTitle ${selectedId === playlist.id ? 'goldenColor2' : ''}`}>{playlist?.title ?? playlist?.name}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <Modal
                show={showModal.open}
                centered
                className="success-modal"
                backdrop="static"
            >
                <Modal.Body>
                    <div className="p-sm-5">
                        <h2 className="font-16 lh-16 my-3 my-sm-5 fw-normal text-center">{showModal.msg} </h2>
                    </div>
                </Modal.Body>
            </Modal>

        </>
    )
}

export default AddToPlaylist